// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","1418":"4138db42","2808":"f34e0124","4715":"f8aecde9","7569":"9b0cb96b","8245":"1b5271a8","8371":"f8aecde9","8719":"1b5271a8","8887":"d792925c"}[chunkId] + ".chunk.css";
};